import { GET_DEPARTAMENTS, ERROR_DEPARTAMENTS } from "../actions/types";

const initialState = {
  departaments: [],
  loading: true,
  error: {},
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_DEPARTAMENTS:
      return {
        ...state,
        departaments: payload,
        loading: false,
      };
    case ERROR_DEPARTAMENTS:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
};
